/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CipherMailFeature = {
    All: 'ALL',
    Cmp: 'CMP',
    Dlp: 'DLP',
    General: 'GENERAL',
    Gateway: 'GATEWAY',
    GlobalSign: 'GLOBAL_SIGN',
    Pdf: 'PDF',
    Pgp: 'PGP',
    Portal: 'PORTAL',
    Smime: 'SMIME',
    Sms: 'SMS',
    SwissSign: 'SWISS_SIGN',
    Webmail: 'WEBMAIL'
} as const;

export type CipherMailFeature = typeof CipherMailFeature[keyof typeof CipherMailFeature];



